/* Florage command-palette search. Live predictive results (/search/suggest.json),
   alias/synonym + prefix expansion, recents (localStorage), full keyboard control. */
(function () {
  'use strict';
  var ov = document.querySelector('[data-cmd-overlay]');
  if (!ov) return;
  var panel = ov.querySelector('[data-cmd-panel]');
  var input = ov.querySelector('[data-cmd-input]');
  var emptyState = ov.querySelector('[data-cmd-empty]');
  var queryState = ov.querySelector('[data-cmd-query]');
  var suggWrap = ov.querySelector('[data-cmd-sugg]');
  var suggChips = ov.querySelector('[data-cmd-sugg-chips]');
  var resultsWrap = ov.querySelector('[data-cmd-results]');
  var countLabel = ov.querySelector('[data-cmd-count]');
  var noResults = ov.querySelector('[data-cmd-noresults]');
  var noResultsQ = ov.querySelector('[data-cmd-noresults-q]');
  var recentsSec = ov.querySelector('[data-cmd-recents]');
  var recentsList = ov.querySelector('[data-cmd-recents-list]');

  var RKEY = 'fl-recent-searches';
  var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
  var searchUrl = (window.routes && window.routes.search_url) || '/search';

  var ALIASES = {
    'calathea': ['korbmarante', 'ctenanthe'], 'korbmarante': ['ctenanthe', 'calathea'],
    'monstera': ['philodendron', 'fensterblatt'], 'bogenhanf': ['sansevieria'], 'sansevieria': ['bogenhanf'],
    'efeutute': ['syngonium', 'pothos'], 'pothos': ['syngonium'], 'purpurtute': ['syngonium'],
    'flamingoblume': ['anthurium'], 'hangepflanzen': ['ceropegia', 'senecio', 'leuchterblume'],
    'hangend': ['ceropegia', 'senecio', 'leuchterblume'], 'ranker': ['ceropegia', 'senecio'],
    'wenig licht': ['aglaonema', 'bogenhanf', 'sansevieria'], 'schatten': ['aglaonema', 'bogenhanf'],
    'luftreinigend': ['sansevieria', 'bogenhanf', 'aglaonema'],
    'pflegeleicht': ['aglaonema', 'sansevieria', 'ficus', 'syngonium'],
    'sukkulenten': ['echeveria', 'senecio', 'opuntia', 'crassula'], 'sukkulente': ['echeveria', 'senecio'],
    'kaktus': ['opuntia'], 'grosse pflanzen': ['xxl', 'gross'], 'gross': ['xxl'],
    'palme': ['chamaedorea', 'bambuspalme'], 'bonsai': ['polyscias', 'ilex']
  };
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function aliasTerms(nq) {
    var out = [], toks = nq.split(/\s+/).filter(Boolean);
    function add(k) { (ALIASES[k] || []).forEach(function (a) { out.push(a); }); }
    if (ALIASES[nq]) add(nq);
    Object.keys(ALIASES).forEach(function (k) {
      if (k === nq) return;
      if (k.indexOf(nq) >= 0 || nq.indexOf(k) >= 0) add(k);
      toks.forEach(function (t) { if (t.length >= 3 && (k.indexOf(t) === 0 || t.indexOf(k) === 0)) add(k); });
    });
    return out.filter(function (v, i, a) { return a.indexOf(v) === i; });
  }

  /* recents */
  function loadRecents() { try { return JSON.parse(localStorage.getItem(RKEY)) || []; } catch (e) { return []; } }
  function saveRecent(q) {
    if (!q || !q.trim()) return;
    var cur = loadRecents().filter(function (x) { return norm(x) !== norm(q); });
    try { localStorage.setItem(RKEY, JSON.stringify([q.trim()].concat(cur).slice(0, 6))); } catch (e) {}
  }
  function clockSvg() { return '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2" stroke-linecap="round"/></svg>'; }
  function renderRecents() {
    var rec = loadRecents();
    if (!recentsSec) return;
    if (!rec.length) { recentsSec.hidden = true; return; }
    recentsSec.hidden = false;
    recentsList.textContent = '';
    rec.forEach(function (r) {
      var chip = document.createElement('span');
      chip.className = 'fl-cmd-chip';
      var label = document.createElement('span');
      label.style.cssText = 'display:inline-flex;align-items:center;gap:8px';
      label.innerHTML = '<span class="fl-cmd-chip__ic">' + clockSvg() + '</span>';
      label.appendChild(document.createTextNode(r));
      label.addEventListener('click', function () { setQuery(r); });
      var x = document.createElement('span');
      x.className = 'fl-cmd-chip__x'; x.textContent = '×';
      x.addEventListener('click', function (e) {
        e.stopPropagation();
        var next = loadRecents().filter(function (v) { return v !== r; });
        try { localStorage.setItem(RKEY, JSON.stringify(next)); } catch (er) {}
        renderRecents();
      });
      chip.appendChild(label); chip.appendChild(x);
      recentsList.appendChild(chip);
    });
  }

  /* open / close */
  function open() {
    ov.classList.add('is-open');
    ov.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    renderRecents();
    setTimeout(function () { input && input.focus(); }, 40);
  }
  function close() {
    ov.classList.remove('is-open');
    ov.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function isOpen() { return ov.classList.contains('is-open'); }

  /* highlight matched substring */
  function highlightInto(el, name, q) {
    el.textContent = '';
    var nq = norm(q), nn = norm(name), i = nq ? nn.indexOf(nq) : -1;
    if (i < 0 || !nq) { el.textContent = name; return; }
    el.appendChild(document.createTextNode(name.slice(0, i)));
    var m = document.createElement('mark'); m.textContent = name.slice(i, i + q.length);
    el.appendChild(m);
    el.appendChild(document.createTextNode(name.slice(i + q.length)));
  }
  function sized(url, w) { if (!url) return ''; return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }
  var CHEV = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg>';

  function buildRow(p, q) {
    var a = document.createElement('a');
    a.className = 'fl-cmd-row'; a.href = p.url; a.setAttribute('data-cmd-row', '');
    var media = document.createElement('div'); media.className = 'fl-cmd-row__media';
    var imgUrl = (p.featured_image && p.featured_image.url) || p.image;
    if (imgUrl) { var im = document.createElement('img'); im.src = sized(imgUrl, 108); im.alt = p.title || ''; im.loading = 'lazy'; media.appendChild(im); }
    var main = document.createElement('div'); main.className = 'fl-cmd-row__main';
    var nm = document.createElement('div'); nm.className = 'fl-cmd-row__name'; highlightInto(nm, p.title || '', q);
    main.appendChild(nm);
    var price = document.createElement('div'); price.className = 'fl-cmd-row__price';
    if (p.price != null && p.price !== '') price.textContent = '€' + String(p.price).replace('.', ',');
    var chev = document.createElement('span'); chev.className = 'fl-cmd-row__chev'; chev.innerHTML = CHEV;
    a.appendChild(media); a.appendChild(main); a.appendChild(price); a.appendChild(chev);
    a.addEventListener('click', function () { saveRecent(input.value || p.title); });
    a.addEventListener('mousemove', function () { setActive(rows.indexOf(a)); });
    return a;
  }

  var rows = [], activeIdx = -1, seq = 0, debTimer = null;
  function setActive(i) {
    if (i < 0 || i >= rows.length) return;
    if (rows[activeIdx]) rows[activeIdx].classList.remove('is-active');
    activeIdx = i; rows[activeIdx].classList.add('is-active');
    rows[activeIdx].scrollIntoView({ block: 'nearest' });
  }

  function showEmpty() {
    queryState.hidden = true; emptyState.hidden = false;
    rows = []; activeIdx = -1;
    renderRecents();
  }

  function fetchJson(term) {
    var url = base + '.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product,collection,query&resources[limit]=8&resources[options][unavailable_products]=last';
    return fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function run(q) {
    var nq = norm(q).trim();
    if (!nq) { showEmpty(); return; }
    emptyState.hidden = true; queryState.hidden = false;
    var mySeq = ++seq;
    fetchJson(q).then(function (j) {
      var res = (j && j.resources && j.resources.results) || {};
      var products = res.products || [];
      var collections = res.collections || [];
      var queries = res.queries || [];
      var al = aliasTerms(nq);
      if (!products.length && al.length) {
        return fetchJson(al[0]).then(function (j2) {
          var r2 = (j2 && j2.resources && j2.resources.results) || {};
          paint(mySeq, q, r2.products || [], collections, queries);
        });
      }
      paint(mySeq, q, products, collections, queries);
    }).catch(function () { if (mySeq === seq) paint(mySeq, q, [], [], []); });
  }

  function paint(mySeq, q, products, collections, queries) {
    if (mySeq !== seq) return;
    /* suggestions: real collections + query suggestions */
    suggChips.textContent = '';
    var sugg = [];
    collections.slice(0, 4).forEach(function (c) { sugg.push({ label: c.title, url: c.url, kind: 'Kategorie' }); });
    queries.slice(0, 3).forEach(function (qq) { sugg.push({ label: qq.text || qq.styled_text, url: qq.url, kind: 'Suche' }); });
    if (sugg.length) {
      suggWrap.hidden = false;
      sugg.forEach(function (s) {
        var a = document.createElement('a'); a.className = 'fl-cmd-chip'; a.href = s.url;
        a.innerHTML = '<span class="fl-cmd-chip__kind">' + s.kind + '</span>';
        a.appendChild(document.createTextNode(s.label));
        suggChips.appendChild(a);
      });
    } else { suggWrap.hidden = true; }

    /* products */
    resultsWrap.textContent = ''; rows = []; activeIdx = -1;
    if (products.length) {
      noResults.hidden = true;
      countLabel.textContent = products.length + ' ' + (products.length === 1 ? 'Produkt' : 'Produkte');
      countLabel.parentNode.hidden = false;
      products.forEach(function (p) { var row = buildRow(p, q); rows.push(row); resultsWrap.appendChild(row); });
      setActive(0);
    } else {
      countLabel.parentNode.hidden = true;
      noResults.hidden = false;
      if (noResultsQ) noResultsQ.textContent = q;
    }
  }

  function setQuery(text) {
    input.value = text;
    panel.classList.toggle('has-q', !!text);
    run(text);
    setTimeout(function () { input.focus(); }, 0);
  }

  /* events */
  input.addEventListener('input', function () {
    panel.classList.toggle('has-q', !!input.value);
    clearTimeout(debTimer);
    var v = input.value;
    debTimer = setTimeout(function () { run(v); }, 130);
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(Math.min(activeIdx + 1, rows.length - 1)); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(activeIdx - 1, 0)); }
    else if (e.key === 'Enter') {
      e.preventDefault();
      if (rows[activeIdx]) { saveRecent(input.value); window.location.href = rows[activeIdx].href; }
      else if (input.value.trim()) { saveRecent(input.value); window.location.href = searchUrl + '?q=' + encodeURIComponent(input.value.trim()); }
    }
  });

  ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
  ov.querySelectorAll('[data-cmd-close]').forEach(function (b) { b.addEventListener('click', close); });
  var clearBtn = ov.querySelector('[data-cmd-clear]');
  if (clearBtn) clearBtn.addEventListener('click', function () { setQuery(''); });
  var clearHist = ov.querySelector('[data-cmd-clearhist]');
  if (clearHist) clearHist.addEventListener('click', function () { try { localStorage.removeItem(RKEY); } catch (e) {} renderRecents(); });

  /* popular / category term chips (server-rendered) */
  ov.querySelectorAll('[data-cmd-term]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); setQuery(el.getAttribute('data-cmd-term')); });
  });

  /* global triggers */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-toggle]')) { e.preventDefault(); open(); }
  });
  window.addEventListener('keydown', function (e) {
    var typing = /input|textarea|select/i.test((document.activeElement && document.activeElement.tagName) || '');
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); isOpen() ? close() : open(); }
    else if (e.key === '/' && !isOpen() && !typing) { e.preventDefault(); open(); }
    else if (e.key === 'Escape' && isOpen()) { close(); }
  });
  /* hero inline field + popular chips on the search page */
  document.addEventListener('click', function (e) {
    var set = e.target.closest('[data-cmd-open-set]');
    if (set) { e.preventDefault(); open(); setTimeout(function () { setQuery(set.getAttribute('data-cmd-open-set')); }, 60); return; }
    if (e.target.closest('[data-cmd-open]')) { e.preventDefault(); open(); }
  });
})();
